// extracted by mini-css-extract-plugin
export var growableInput = "_94-0";
export var tagContainer = "_94-2";
export var textInput = "_94-1";